@if (loaded()) {
<app-route-page>
  <div
    class="d-flex flex-column align-items-center payment-center-container"
    [ngClass]="{'psic-gap-8': !isMobile(), 'psic-gap-6': isMobile() }"
    >
    <h2>Payment Center</h2>
    <div class="d-flex flex-column psic-gap-6">
      <div class="d-flex flex-row psic-gap-2 results-row">
        <h6>Results for:</h6>
        <p class="p-alt">{{referenceNumberType()}} {{referenceNumberValue()}}</p>
      </div>
      <app-information-card [field]="policyDataField()!"></app-information-card>
      <div class="infoSection">
        @if (disablePaymentOption()) {
          <lib-alert
            [alertText]="disablePaymentAlert()"
            [alertTheme]="'error'"
            [alertType]="'small'"
          ></lib-alert>
        }
        @if (noOutstandingBalance()) {
          <lib-alert
            [alertText]="globalConstants.noDueMsg"
            [alertTheme]="'success'"
            [alertType]="'small'"
            [inputIcon]="'check-circle'"
          ></lib-alert>
        }
      </div>
    </div>
    <app-navigation-footer
      [goBack]="true"
      [continue]="true"
      [continueButtonText]="'Make a Payment'"
      [showButton]="!showPaymentButton()"
      (navigatePage)="makePayment($event)"
    ></app-navigation-footer>
    @if (showPaymentButton()) {
      <div class="d-flex flex-column psic-gap-6 check-out-products">
        @if (!isMobile()) {
          <h3>{{globalConstants.interestedProtectionMsg}}</h3>
        }
        @if (isMobile()) {
          <h6>{{globalConstants.interestedProtectionMsg}}</h6>
        }
        <div class="d-flex flex-row justify-content-center" [ngClass]="{'psic-gap-8': !isMobile(), 'psic-gap-4': isMobile()}">
          @for (item of policies(); track item) {
            <div class="d-flex flex-column psic-gap-2 align-items-center policy-icon" (click)="goToPage(item)">
              <img [src]="item.icon" [alt]="item.product" />
              <span class="disclaimer">{{ item.product }}</span>
            </div>
          }
        </div>
      </div>
    }
  </div>
</app-route-page>
<app-footer-image></app-footer-image>
}
